import React, { useRef, useState } from 'react';
import { LinkedInProfilePackage, exportLinkedInPackagePdf, validateLinkedInPackage, LinkedInPackageData } from '@/components/LinkedInProfilePackage';
import sample from '@/testdata/sample-linkedin-package.json';

// Dev/QA harness: renders the LinkedIn Profile Package with the approved
// Evonne Torrence sample so the port can be compared page by page against the
// reference HTML. Route: /li-package-preview
const LinkedInPackagePreview: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [fit, setFit] = useState<string>('measuring…');
  const data = sample as unknown as LinkedInPackageData;
  const copyIssues = validateLinkedInPackage(data);

  return (
    <div style={{ background: '#eef1f6', minHeight: '100vh', padding: 28 }}>
      <div style={{ marginBottom: 14, display: 'flex', gap: 14, alignItems: 'center', flexWrap: 'wrap' }}>
        <button
          style={{ padding: '8px 16px', background: '#244061', color: '#fff', borderRadius: 6 }}
          onClick={() => ref.current && exportLinkedInPackagePdf(ref.current, data.client.fullName)}
        >
          Download PDF
        </button>
        <span data-testid="fit" style={{ fontSize: 13 }}>fit: {fit}</span>
        <span data-testid="copy" style={{ fontSize: 13, color: copyIssues.length ? '#b91c1c' : '#166534' }}>
          copy rules: {copyIssues.length ? copyIssues.join(' | ') : 'clean'}
        </span>
      </div>
      <div ref={ref}>
        <LinkedInProfilePackage
          data={data}
          onFitResult={(r) => setFit(r.ok ? `ok, ${r.pageCount} pages` : `OVERFLOW: ${r.overflows.join('; ')}`)}
        />
      </div>
    </div>
  );
};

export default LinkedInPackagePreview;
